import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import * as React from 'react';
import TicketsTable from './ticketsTable';

export default function TicketSection({ myTickets, allTickets, operator_id }) {
  const [view, setView] = React.useState("mine");

  const handleChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  return (
    <div style={{ position: "relative", zIndex: 1, marginTop: "3rem" }}>
      {/* PILLS MUI */}
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleChange}
        aria-label="ticket view toggle"
        sx={{ marginBottom: 2 }}
      >
        <ToggleButton value="mine" aria-label="I miei ticket">
          I miei ticket
        </ToggleButton>
        <ToggleButton value="all" aria-label="Tutti i ticket">
          Tutti i ticket
        </ToggleButton>
      </ToggleButtonGroup>

      {/* TABELLE */}
      {view === "mine" ?
        <TicketsTable rows={myTickets} operator_id={operator_id} />
        :
        <TicketsTable rows={allTickets} print_operator={true} operator_id={operator_id} />
      }
    </div>
  );
}